import { useEffect, useRef } from "react";

import type { HotelMapRuntime } from "../runtime";

type HotelMapCanvasProps = Pick<HotelMapRuntime, "mount">;

/** 提供稳定的第三方地图挂载节点，并将资源清理由 runtime 统一负责。 */
export function HotelMapCanvas({ mount }: HotelMapCanvasProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      void mount(container).catch(() => undefined);
    }
  }, [mount]);

  return (
    <div
      ref={containerRef}
      className="hotel-map-canvas"
      data-testid="hotel-map-canvas"
      aria-label="酒店地图"
    />
  );
}
